import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InboundNumberProvider } from '../../../../core/interfaces/inbound/inbound-number-provider';
import { ViewInboundActiveNumberSettingsFormService } from './view-inbound-active-number-settings-form.service';
import { ViewInboundActiveNumberSettingsLoaderService } from './view-inbound-active-number-settings-loader.service';

@Component({
  selector: 'app-view-inbound-active-number-settings',
  templateUrl: './view-inbound-active-number-settings.component.html',
  styleUrl: './view-inbound-active-number-settings.component.scss',
  providers: [ViewInboundActiveNumberSettingsFormService, ViewInboundActiveNumberSettingsLoaderService]
})
export class ViewInboundActiveNumberSettingsComponent implements OnInit {
  public isUserBaseAuth = false;
  public providers: InboundNumberProvider[] = [];

  constructor(public dialogRef: MatDialogRef<ViewInboundActiveNumberSettingsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any | null,
    private formService: ViewInboundActiveNumberSettingsFormService,
    private loaderService: ViewInboundActiveNumberSettingsLoaderService) {

    
  }

  ngOnInit() {
    this.provider.valueChanges.subscribe(value => {
      let provider = this.providers.find(x => x.id == value);
      this.isUserBaseAuth = provider != null && provider.authenticationType == "User";

      if (this.isUserBaseAuth == true) {
        this.formService.makeAllFieldsRequired();
      }
      else {
        this.formService.removeFieldsRequired();
      }
    });

    if (this.data) {
      if (this.data.connectionSettings !=null) {
        const connectionSettings = JSON.parse(this.data.connectionSettings);
        this.loaderService.loadData(connectionSettings);
      }

      this.providers = this.data.providerList;
      this.provider.patchValue(this.data.provider);
      this.internalNumber.patchValue(this.data.internalTelephoneNumber);
    }
  }

  get form() {
    return this.formService.form;
  }

  get user() {
    return this.formService.getControlName("user");
  }

  get authUser() {
    return this.formService.getControlName("authUser");
  }

  get secret() {
    return this.formService.getControlName("secret");
  }

  get host() {
    return this.formService.getControlName("host");
  }

  get port() {
    return this.formService.getControlName("port");
  }

  get extension() {
    return this.formService.getControlName("extension");
  }

  get telephoneNumber() {
    return this.formService.getControlName("telephoneNumber");
  }
  
  get provider() {
    return this.formService.getControlName("provider");
  }
  get internalNumber() {
    return this.formService.getControlName("internalNumber");
  }

  save(): void {
    let settings = this.formService.createSerializedConnectionSettings();


    this.dialogRef.close({ connectionSettings: settings, provider: this.provider.value, internalTelephoneNumber:this.internalNumber.value });
  }

  close(): void {
    this.dialogRef.close(null);
  }
}
